<script>
    import Hud from "./Hud.svelte";
    import HudTop from "./HudTop.svelte";
    import DecisionMaker from "./DecisionMaker.svelte";
</script>

<div class="hud-container glow-border">
    
    <div class="hologram ">
            <DecisionMaker />
    </div>
    
    <div class="hud-bottom">
        <Hud />
    </div>
</div>


<style>
.glow-border {
    border: 2px solid transparent;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    animation: pulse 2s infinite alternate;
    box-shadow: 0 0 10px 0 #FD8834;
  }

  @keyframes pulse {
    0% {
      border-color: #FD8834;
      box-shadow: 0 0 10px 0 orange;
    }
    100% {
      border-color: orange;
      box-shadow: 0 0 20px 5px rgba(255, 165, 0, 0.5);
    }
  }
 
    /* Define the animation */
    @keyframes fadeInGrow {
    from {
        opacity: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
    }

    @keyframes fadeInGrowY {
    from {
        opacity: 0;
        transform: scaleY(0);
    }
    to {
        opacity: 1;
        transform: scaleY(1);
    }
    }

    


    
    .hologram{
        width: 100%;
        height: 100%;
        margin: 24px;
        box-sizing: border-box;
        background-color: rgba(255,107,1,0.02);
        display: flex;
        flex-direction: column;
        gap: 12px; 
         justify-content: flex-end;
    } 
    .hud-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: auto;
        height: 100%;
        justify-content: space-between;
        animation:  fadeInGrowY .3s ease-in forwards;
        position: relative;
        border: 1px solid #FF8934;
        background-color: rgba(255,107,1,0.05);
        padding: 24px   ;
        margin: 24px auto;
        width: 500px;
        border-radius: 24px;
    }

    .hud-top{
        top: 0px;
        animation:  fadeInGrow .6s ease-out forwards; 
        transform-origin: top;
        max-width: 400px;
            
    }

    .hud-bottom{
        bottom: 0px;
       animation:  fadeInGrow .6s ease-out forwards; 
        transform-origin: bottom;
       max-width: 400px;
    }    


</style>